<div class="modelContainer alignCenter">
  <div class="">
      <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle heading2">
    {{data.title}}?
    
  </div>
  <div class="modelBody">
    <div *ngIf="data.isDelete">
      <div class="icon"><img src="../../../assets/delete_status_icon.svg" alt="Delete" /></div>
      <div   class="sureMsg">
        <div class="displayInline" [innerHtml]="data.message"></div><input *ngIf="data.isDelete && chkDelKv" class="form-check-input delCheckbox" type="checkbox" name="chkConfirm" [(ngModel)]="isChecked" [checked]="this.isChecked" (click)="KvSelection(this.isChecked)" />
        <br />Caution: This process cannot be undone.
      </div>
     
      <div class="buttons">
        <button class="actionBtn secondaryBtn" tabindex="0" (click)="onCancelClick()">Cancel</button>
        <button *ngIf="data.isDelete" class="actionBtn primaryBtn" tabindex="0" (click)="intendedAction()">Delete</button>
        <div class="clear"></div>
      </div>
    </div>
    <div *ngIf="!data.isDelete">
      <div class="icon"><img src="../../../assets/alert_status_icon.svg" alt="Confirm" /></div>
      <div class="sureMsg">
        {{data.message}}
        <br />Click "OK" to continue.
      </div>
      <div class="buttons">
        <button class="actionBtn primaryBtn" tabindex="0" (click)="intendedAction()">OK</button>
        <button class="actionBtn secondaryBtn" tabindex="0" (click)="onCancelClick()">Cancel</button>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</div>

